import _axios from "../../index";
import qs from 'qs'
//时间戳余额.
export const orderBalance = () =>
    _axios({
        url: '/order/balance',
        method: "get",
    });

//账户概览（主）
export const overviewNum = data =>
    _axios({
        url: '/order/overview',
        method: "get",
        params: data,
    });

//账户概览（子）
export const overviewChildNum = data =>
    _axios({
        url: '/order/user/overview',
        method: "get",
        params: data,
    });



//获取列表
export const getSuite = () =>
    _axios({
        url: '/suite/search',
        method: "get",
    });

//下单前获取订单ID,防止重复下单.
export const getOrderId = () =>
    _axios({
        url: '/order/getOrderId',
        method: "get",
    });

//微信支付
export const nativeBuy = data =>
    _axios({
        url: '/order/nativeBuy',
        method: "post",
        data
    });


//消费流水
export const orderTransactionList = params =>
    _axios({
        url: '/orderTransactionLog',
        method: "get",
        params,
        paramsSerializer: function (params) {
            return qs.stringify(params, { arrayFormat: "repeat" });
        },
    });

//欠费记录
export const oweList = data =>
    _axios({
        url: '/owe/search',
        method: "get",
        params: data
    });

//即将过期
export const expireData = data =>
    _axios({
        url: '/order/search',
        method: "get",
        params: data
    });

//发送邮箱验证码.
export const sendMailCode = data =>
    _axios({
        url: '/exportRecord/sendMailCode',
        method: "post",
        data,
    });

//保存申请下载任务记录.
export const exportRecord = data =>
    _axios({
        url: '/exportRecord/create',
        method: "post",
        data,
    });

//是否有转出记录.
export const userOrderOutflow = data =>
    _axios({
        url: '/order/userOrderOutflow',
        method: "get",
    });


//验证报告订单.
export const searchVerifyOrders = data =>
    _axios({
        url: '/independent/order/searchVerifyOrders',
        method: "get",
        params: data
    });


//取消验证报告订单
export const orderCancel = data =>
    _axios({
        url: '/independent/order/cancel',
        method: "put",
        data,
    });

//验证报告下载
export const downloadPdfReport = params =>
    _axios({
        url: '/independent/order/verify/downloadPdfReport',
        method: "get",
        params,
    });

//我的优惠券列表
export const getCouponList = params =>
    _axios({
        url: '/coupon/search',
        method: "get",
        params
    });

//选择套餐可用优惠券
export const getAvailableCoupon = params =>
    _axios({
        url: '/coupon/findAvailableCoupon',
        method: "get",
        params,
        stopLoading: true,
    });

//根据订单id获取订单详情
export const getDetailByOrderId = params =>
    _axios({
        url: '/order/findById',
        method: "get",
        params
    });
    
// 支付挽留赠送优惠券资格查询
export const paymentRetentionPopStatus = params =>
    _axios({
        url: '/paymentRetention/popStatus',
        method: "get",
        params
    });


//支付挽留赠送优惠券
export const paymentRetentionGiftCoupon = data =>
    _axios({
        url: '/paymentRetention/giftCoupon',
        method: "post",
        data,
    });
